import "./Home.module.css";
import StillOfficialPremiumHeader from "@/reusable_sections/Header";
import TheFutureOfTechHero from "./sections/TheFutureOfTechHero";
import ModCategories from "./sections/ModCategories";
import FloresDestacadas from "./sections/FloresDestacadas";
import InnovatorImpactMetrics from "./sections/InnovatorImpactMetrics";
import ReadyToTransformHealthcare from "./sections/ReadyToTransformHealthcare";
import InformativeFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <StillOfficialPremiumHeader />
      <TheFutureOfTechHero />
      <ModCategories />
      <FloresDestacadas />
      <InnovatorImpactMetrics />
      <ReadyToTransformHealthcare />
      <InformativeFooter />
    </div>;
}